{
  "REGISTER": {
    "TRY_WOOT": "Создать новый аккаунт",
    "TITLE": "Регистрация",
    "TESTIMONIAL_HEADER": "Все, что нужно сделать, это один шаг для продвижения вперед",
    "TESTIMONIAL_CONTENT": "Вы находитесь на расстоянии всего одного шага от привлечения своих клиентов, удержав их и находя новые.",
    "TERMS_ACCEPT": "Создавая учетную запись, вы соглашаетесь с нашими <a href=\"https://chat.jarabot.com/terms\">Т и С</a> и <a href=\"https://chat.jarabot.com/privacy-policy\">политикой конфиденциальности</a>",
    "TERMS_LINKS": "<a href=\"https://chat.jarabot.com/terms\">Условия использования</a> - <a href=\"https://chat.jarabot.com/privacy-policy\">Политика конфиденциальности</a>",
    "OAUTH": {
      "GOOGLE_SIGNUP": "Регистрация через Google"
    },
    "COMPANY_NAME": {
      "LABEL": "Название компании",
      "PLACEHOLDER": "Введите название вашей компании например Wayne Enterprises",
      "ERROR": "Название компании слишком короткое."
    },
    "FULL_NAME": {
      "LABEL": "Полное имя",
      "PLACEHOLDER": "Введите ваше полное имя. Например: Брюс Уэйн",
      "ERROR": "Имя слишком короткое."
    },
    "EMAIL": {
      "LABEL": "Рабочий email",
      "PLACEHOLDER": "Введите ваш рабочий адрес электронной почты. Например: bruce{'@'}wayne{'.'}enterprises",
      "ERROR": "Пожалуйста, введите действительный адрес электронной почты."
    },
    "PASSWORD": {
      "LABEL": "Пароль",
      "PLACEHOLDER": "Пароль",
      "ERROR": "Пароль слишком короткий.",
      "IS_INVALID_PASSWORD": "Пароль должен содержать хотя бы одну заглавную букву, одну строчную букву, 1 цифру и 1 специальный символ."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Подтвердите пароль",
      "PLACEHOLDER": "Подтвердите пароль",
      "ERROR": "Пароли не совпадают."
    },
    "API": {
      "SUCCESS_MESSAGE": "Успешная регистрация",
      "ERROR_MESSAGE": "Не удалось подключиться к Woot серверу. Пожалуйста, попробуйте еще раз."
    },
    "SUBMIT": "Создать новый аккаунт",
    "HAVE_AN_ACCOUNT": "Уже есть аккаунт?"
  }
}
